import React from 'react';
import { Skelton } from '../../components/Skelton/Skelton';
import './EmptyDashboard.scss';
import { Grid } from '@scuf/common';
import useWindowSize from '../../utils/useWindowSize';
import { BREAKPOINTS } from '../../constants/constants';
 
const EmptyDashboard = () => {
    const { width } = useWindowSize();
    const largeDevice = width && width > BREAKPOINTS.MD ? true : false;
    const smallDevice = width && width <= BREAKPOINTS.XS ? true : false;
    const mediumAndSmallDevice = width && width <= BREAKPOINTS.MD? true: false; 
    return (
        <div className="home-tab empty_state">
            <div className="empty_state__tab">
                <Skelton width={smallDevice?"160px":"15%"} height={"26px"} class={"empty_state__tab-1"}></Skelton>
                <Skelton width={smallDevice?"160px":"15%"} height={"26px"}></Skelton>
            </div>
            <div className="empty_state__heading">
                <Skelton width={smallDevice?"201px":"25%"} height={"20px"} class={"empty_state__heading-1"} ></Skelton>
                <Skelton width={smallDevice?"274px":"45%"} height={"26px"} class={"empty_state__heading-1"} ></Skelton>
            </div>
            { !largeDevice &&
            <div className="empty_state__title">
                <Skelton width={smallDevice?"90%":"70%"} height={"26px"}></Skelton>
            </div>
            }
            <div>
                <Grid.Row>
                    <Grid.Column className={"empty_state__cards"} width={smallDevice?12:mediumAndSmallDevice?6:4}>
                        <Skelton height="38vh" class="cards__skelton"></Skelton>
                    </Grid.Column>
                    <Grid.Column width={smallDevice?12:mediumAndSmallDevice?6:4}>
                        <Skelton height="38vh" class="cards__skelton"></Skelton>
                    </Grid.Column>
                    {!smallDevice && !mediumAndSmallDevice && <>
                    <Grid.Column  width={4}>
                        <Skelton height="38vh" class="cards__skelton"></Skelton>
                    </Grid.Column> </>}
                </Grid.Row>
            </div>
            {!smallDevice && !mediumAndSmallDevice &&
            <div className="empty_state__kpi">
                <Skelton width={"30%"} height={"26px"}  ></Skelton>
                <div>
                    <Grid.Row>
                        <Grid.Column className={"empty_state__cards"} xlWidth={4} lWidth={4} >
                            <div className="empty_state__kpi--item">
                                <Skelton height="20px" width="20%"  ></Skelton>
                                <Skelton height="20px" width="40%"  ></Skelton>
                                <Skelton height="20px" width="60%"  ></Skelton>
                            </div>


                        </Grid.Column>
                        <Grid.Column xlWidth={4} lWidth={4} >
                            <div className="empty_state__kpi--item">
                                <Skelton height="20px" width="20%"  ></Skelton>
                                <Skelton height="20px" width="40%"  ></Skelton>
                                <Skelton height="20px" width="60%"  ></Skelton>
                            </div>
                        </Grid.Column>
                        <Grid.Column xlWidth={4} lWidth={4} >
                            <div className="empty_state__kpi--item">
                                <Skelton height="20px" width="20%"  ></Skelton>
                                <Skelton height="20px" width="40%"  ></Skelton>
                                <Skelton height="20px" width="60%"  ></Skelton>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </div>
            </div>}
        </div>
    )
}

export default EmptyDashboard;